/**
 * API 配置常量
 */
/** API 请求默认超时（毫秒） */
export const API_TIMEOUT_MS = 30000;
/** Versioned API prefix for frontend request paths. */
export const API_V1_PATH = '/api/v1';
/** Versioned API prefix for NestJS global prefix configuration. */
export const API_V1_PREFIX = 'api/v1';
/** Swagger docs path mounted by both backends in non-production mode. */
export const API_V1_DOCS_PATH = 'api/v1/docs';
/** Shared auth route used by mobile and MES apps for redirect-on-401. */
export const APP_LOGIN_ROUTE = '/login';
/** Shared MES login endpoint used to avoid intercepting the auth request itself. */
export const MES_LOGIN_ENDPOINT = '/api/v1/users/login';
/** Shared CSRF/XHR header name and value used by clients and guards. */
export const X_REQUESTED_WITH_HEADER = 'x-requested-with';
export const X_REQUESTED_WITH_VALUE = 'XMLHttpRequest';
/** ERP 后端默认 URL（开发环境） */
export const DEFAULT_ERP_API_URL = 'http://localhost:3001';
/** MES 后端默认 URL（开发环境） */
export const DEFAULT_MES_API_URL = 'http://localhost:4001';
/** 前端开发服务器默认端口 */
export const DEFAULT_PORTS = {
    ERP_FRONTEND: 3000,
    MES_FRONTEND: 3002,
    VITE_DEV: 5173,
    ERP_BACKEND: 3001,
    MES_BACKEND: 4001,
};
/** 开发环境默认 CORS 允许来源 */
export const DEFAULT_CORS_ORIGINS = [
    'http://localhost:3000', // ERP Desktop (Next.js)
    'http://localhost:3002', // MES Client (Vite)
    'http://localhost:5173', // MES Client (Vite alt port)
    'http://localhost:1420', // ERP Mobile (Tauri/Vite)
    'http://localhost:1421', // MES Mobile (Tauri/Vite)
    'http://localhost:1422', // ERP Mobile (Vite alt port)
    'http://192.168.1.10:3000', // ERP Desktop (LAN)
    'http://192.168.1.10:3002', // MES Client (LAN)
    'https://192.168.1.10:3000', // ERP Desktop (LAN HTTPS)
    'https://192.168.1.10:3002', // MES Client (LAN HTTPS)
    'https://localhost:3000', // ERP Desktop (HTTPS)
];
